(function () {
    const checkFreeGift = setInterval(() => {
        try {
            if (window.tlFreeGiftOffer && window.tlFreeGiftOffer.utils) {
                clearInterval(checkFreeGift);

                const originalCreateError = window.tlFreeGiftOffer.utils.createAjaxCartErrorResponse;
                if (typeof originalCreateError !== 'function') return;

                window.tlFreeGiftOffer.utils.createAjaxCartErrorResponse = function (statusCode, errMessage) {
                    try {
                        if (typeof errMessage === 'string' && errMessage.includes("You can't add more")) {
                            const match = errMessage.match(/^You can't add more (\d+) (.*) to the cart\.$/);
                            if (match) {
                                const quantity = match[1] || '';
                                const title = match[2] || '';
                                const template = "You cannot add or delete this item. You must add or delete its parent.";

                                errMessage = template
                                    .replace("{{quantity}}", quantity)
                                    .replace("{{title}}", title);
                            }
                        }
                    } catch (e) {}

                    return originalCreateError.call(this, statusCode, errMessage);
                };
            }
        } catch (e) {}
    }, 50);
})();
